import { animate, sequence, state, style, transition, trigger } from "@angular/animations";
import { Location } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatSidenav } from "@angular/material";
import { Router } from "@angular/router";
import * as moment from "moment";
import { Observable, Subscription } from "rxjs";
import { environment } from "../../../../environments/environment";
import { appConfig } from "../../core-config";
import { CookiePolicyComponent } from "../../modalDialogs/cookiePolicy/cookiePolicy.component";
import { LanguageDialogComponent } from "../../modalDialogs/languageDialog/languageDialog.component";
import { LoginDialogComponent } from "../../modalDialogs/logindialog/logindialog.component";
import { LicenseDialogComponent } from "../../modalDialogs/licenseDialog/licenseDialog.component";
import { MenuChangeLocationDialogComponent } from "../../modalDialogs/menuChangeLocationDialog/menuChangeLocationDialog.component";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { CircularInjectionHelper } from "../../services/circularInjectionHelper";
import { CoreCOMService } from "../../services/com.service";
import { ClientType } from "../../services/com/comEnvironmentClient";
import { CommunicationData } from "../../services/communicationdata.service";
import { EMenuService } from "../../services/emenu.service";
import { ExternalLinksSettingsService } from "../../services/ExternalLinksSettings.service";
import { InHouseOrderService } from "../../services/inHouseOrder.service";
import { IObjectObserver } from "../../services/IObjectObserver";
import { CoreLogService } from "../../services/log.service";
import { NavigationService } from "../../services/navigation.service";
import { ObjectObserverFactory } from "../../services/objectObserverFactory";
import { RouterHelperService } from "../../services/routerHelper.service";
import { SettingsService } from "../../services/settings.service";
import { snackBarMessageKey, SnackBarService } from "../../services/snackBar.service";
import { UserHelperService } from "../../services/userHelper.service";
import { WebShopService } from "../../services/webShop.service";
import { plopInOut } from "../../shared/animation/component.animation";
import { ContentType, SnackBarMessageType, WebShopMode } from "../../shared/contentTypes";
import { ImpressumTermViewModel, MenuSettingsDataModel2, MenuSettingsDMKey, WebshopSettingsDataModel2, WebshopSettingsDMKey } from "../../shared/models";
import { NavigationViewModel } from "../../shared/models/navigation.model";
import { NavigationRoute } from "../../shared/enums/navigation-route.enum";
import { UserInfoViewModel } from "../../shared/models/userInfo.model";
import { LocationService } from "../location/location.service";
import { TermService } from "../term/term.service";
import { AccessibilityWebShopService } from '../../services/accessibilityWebShop.service';
import { AccessibiltyDialogComponent } from "../../modalDialogs/accessibiltyDialog/accessibiltyDialog.component";
import { ConfirmationModalDialogComponent } from "../../modalDialogs";
import { Community, MainnavService, Paymentoption, ViewType } from "./mainnav.service";
import { LocalKeys, StorageHive } from "../../services/valueStorage.service";
import { RemoteGroupOrderService } from "../../services/RemoteGroupOrder.service";
import Utils from "../../shared/utils";

@Component({
  selector: "main-nav",
  templateUrl: "./mainNav.component.html",
  styleUrls: ["./mainNav.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("toggleBottomNav", [
      state(
        "false",
        style({ opacity: 0, transform: "translateY(100%)" })
      ),
      state(
        "true",
        style({ opacity: 1, transform: "translateY(0)" })
      ),
      transition("true <=> false", animate("200ms ease-in-out")),
    ]),
    trigger("toggleOfflineIndicator", [
      state(
        "false",
        style({ height: "0", "background-color": "*" })
      ),
      state(
        "true",
        style({ height: "calc(var(--vh) * 3)", "background-color": "*" })
      ),
      transition("false => true", animate("200ms ease-out")),
      transition("true => false",
        sequence([animate("200ms ease-in-out", style({ "background-color": "{{activeColor}}" })), animate("400ms 1.75s ease-out")]),
        { params: { activeColor: "#FFF" } })
    ]),
    plopInOut
  ]
})

export class MainNavComponent implements OnInit, OnDestroy {
  @ViewChild('stickyMenu') menuElement: ElementRef;
  sticky: boolean = false;
  elementPosition: any;

  //ngAfterViewInit() {
  //  const me = this;
  //  if (me.menuElement) {
  //    me.elementPosition = me.menuElement.nativeElement.offsetTop;
  //  }
  //}

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    if (window.pageYOffset > 250) {
      let element = document.getElementById('mainNav');
      if (element) {
        element.classList.add('sticky');
      }
    } else {
      let element = document.getElementById('mainNav');
      if (element) {
        element.classList.remove('sticky');
      }
    }
  }

  public isProductionMode = environment.production;
  public isMobile: boolean;
  public isIOS: boolean;
  public isEMenu: boolean;
  public hideFooter: boolean = false;
  public showCookiebanner: boolean = true;
  public useNavigation: boolean = true;
  public isSmallView: boolean = false;
  private _viewTypeSubscription: Subscription;

  // @ViewChild("userProfile") userProfile: MatSidenav;
  public userInfoViewModel: UserInfoViewModel;
  public _navigationViewModel: NavigationViewModel[];
  public isVisible = true;
  public isOffline = false;
  public subMenu: NavigationViewModel[];
  public mainMenu: NavigationViewModel[];
  public fullFooterMenu: boolean = true;
  // use Translation method to bind it to UI
  public aboutUs: string;
  public isRegistered: boolean = false;

  // InHouse
  public inHouseIsGroup: boolean = false;
  public inHouseHasTableSeat: boolean = false;
  public inHouseTableOpenItems: number = 0;
  //Remote group order
  public displayRemoteOrderGroupIcon$: Observable<boolean>;
  public groupStatusFinished$: Observable<boolean>;
  public remoteGroupMemberCount$: Observable<number>;
  /** anzahl der gruppen mitglieder */
  public inHouseGroupMemberCount: number = 0;
  public offlineIndicatorActiveColor: string;
  public sideNavOpened: boolean = false;
  public emptybasket: boolean = true;
  public itemsInBasket: number = 0;
  public isLocationCheckedIn: boolean = false;
  public isLocationModuleActive: boolean = false;
  public isRevokeEnabled: boolean = false;
  public now: moment.Moment = moment();

  // Footer data - shared via MainnavService
  public get paymentoptions(): Paymentoption[] {
    return this._mainnavService.paymentoptions;
  }
  public get communities(): Community[] {
    return this._mainnavService.communities;
  }
  public get version(): string {
    return this._mainnavService.version;
  }
  public get company_name(): string {
    return this._mainnavService.company_name;
  }
  public get terms(): ImpressumTermViewModel[] {
    return this._mainnavService.terms;
  }
  public get isAccessibilityModeActive(): boolean {
    return this._mainnavService.isAccessibilityModeActive;
  }
  public get canSelectLanguage(): boolean {
    return this._mainnavService.canSelectLanguage;
  }
  public get currentLocale(): string {
    return this._mainnavService.currentLocale;
  }

  private langSubscriber: Subscription;
  private navigationChangesSubscriber: Subscription;
  private onlineSupscription: Subscription;
  private offlineSupscription: Subscription;
  private _shippingCartSubscriber: Subscription;
  private _inHouseUiDataSubscription: Subscription;
  private _navigationEnabledSubscription: Subscription;
  private _navigationBackSubscription: Subscription;
  private _mainFooterSubscription: Subscription;
  private _highLightNavigationSubscription: Subscription;
  private _lastChildRouteDataSubscription: Subscription;
  private _menuSettingObsServ: IObjectObserver<MenuSettingsDataModel2>;
  private _webshopSettingsObsServ: IObjectObserver<WebshopSettingsDataModel2>;
  private _webshopSettingsChanged: Subscription;
  private _accessibilityModeSubscription: Subscription;
  @ViewChild("drawer") drawer: MatSidenav;
  constructor(private _communicationData: CommunicationData
    , private _coreCOMService: CoreCOMService
    , private _router: Router
    , private _mainnavService: MainnavService
    , private _navigationService: NavigationService
    , private _coreLogService: CoreLogService
    , private _userHelperService: UserHelperService
    , private _snackBarService: SnackBarService
    , private _settingsService: SettingsService
    , private _routerHelperService: RouterHelperService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _location: Location
    , private _externalLinksSettingsService: ExternalLinksSettingsService
    , private _eMenuService: EMenuService
    , private _locationService: LocationService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _termService: TermService
    , private objObsInjectHelper: CircularInjectionHelper
    , private _webShopService: WebShopService
    , private _InHouseOrderService: InHouseOrderService
    , private _accessibilityWebShopService: AccessibilityWebShopService
    , private _remoteGroupOrderService: RemoteGroupOrderService) {
    const me = this;
    me._menuSettingObsServ = ObjectObserverFactory.GetObjectObserverByInjectionHelper<MenuSettingsDataModel2>(ContentType.MenuSettings, objObsInjectHelper);
    me._webshopSettingsObsServ = ObjectObserverFactory.GetObjectObserverByInjectionHelper<WebshopSettingsDataModel2>(ContentType.WebshopSettings, objObsInjectHelper);

    me.isMobile = me._coreCOMService.environment.client.isMobile;
    me.isIOS = me._coreCOMService.environment.client.isMobile && me._coreCOMService.environment.client.type === ClientType.ios;
    me.onlineSupscription = me._coreCOMService.environment.events.online.subscribe(() => {
      if (me.isOffline != false) {
        me.isOffline = false;
        me.PushChanges();
      }
    });

    me.offlineSupscription = me._coreCOMService.environment.events.offline.subscribe(() => {
      if (me.isOffline != true) {
        me.isOffline = true;
        me.PushChanges();
      }
    });

  }

  ngOnInit(): void {
    const me = this;

    me._mainnavService.version = this.getVersionAsString();
    me._mainnavService.company_name = appConfig.company;

    me.isEMenu = me._eMenuService.isActive;

    me.CommunityInfoLoad();


    me.navigationChangesSubscriber = me._navigationService.ObserveChanges.subscribe((changed) => {
      me.ReloadDataAndRender();
    });
    me._mainnavService.isAccessibilityModeActive = this._accessibilityWebShopService.getAccessibilityModeActive();

    me._accessibilityModeSubscription = me._accessibilityWebShopService.accessibilityModeActive$.subscribe((isActive) => {
      me._mainnavService.isAccessibilityModeActive = isActive;
      me.PushChanges();
    });

    me.langSubscriber = me._communicationData.LanguageChoice().subscribe((languageChoice: string) => {
      if (me._mainnavService.currentLocale != languageChoice) {
        me._mainnavService.currentLocale = languageChoice;
        me._setHtmlLanguage(me.currentLocale)
        me.PushChanges();
      }
    });

    // close side menu when it is opened and we navigate back with android phone navigation
    me._navigationBackSubscription = me._coreCOMService.environment.events.navigationBack.subscribe(() => {
      if (me.drawer.opened) {
        me.drawer.close();
        me._changeDetectorRef.detectChanges();
      } else {
        me._location.back();
      }
    });

    // check footer status by each route change.
    me._mainFooterSubscription = me._routerHelperService.MainFooterObserver.subscribe(hideFooter => {
      if (me.hideFooter != hideFooter) {
        me.hideFooter = hideFooter;
        me.PushChanges();
      }
    });

    me._routerHelperService.ShowCookiebannerObserver.subscribe(showCookiebanner => {
      me.showCookiebanner = showCookiebanner;
      me.PushChanges();
    });

    me._highLightNavigationSubscription = me._routerHelperService.HighLightNavigationObservable.subscribe((contentType: number) => {
      me.setTargetModuleHighlight(contentType);
    });

    me._lastChildRouteDataSubscription = me._routerHelperService.LastChildRouteDataObservable.subscribe((routeData: any) => {
      if (routeData) {
        me.isLocationCheckedIn = (routeData["showLocationCheckedIn"] === true && me._webShopService.locationID != null);
      }
    });

    me.useNavigation = me._mainnavService.navigationEnabled;
    me._navigationEnabledSubscription = me._mainnavService.navigationEnabled$.subscribe((enabled) => {
      if (me.useNavigation != enabled) {
        me.useNavigation = enabled;
        me.PushChanges();
      }
    });

    // check if user is registered or not. it affect on top left icon.
    // if it is true top left icon route to profile and if it is false it opens login dialog.
    me._userHelperService.RegisterObserver.subscribe((registered) => {
      if (me.isRegistered != registered) {
        me.isRegistered = registered;
        me.PushChanges();
      }
    });

    const UiData = me._InHouseOrderService.UiData;
    me.inHouseHasTableSeat = UiData.place_no > 0;
    me.inHouseIsGroup = UiData.isGroup;
    me.inHouseTableOpenItems = UiData.open_amount;
    me.inHouseGroupMemberCount = UiData.customer_count;
    // bei änderung des Tisches im InHouseOrder entsprechend die UI aktualisieren
    me._inHouseUiDataSubscription = me._InHouseOrderService.ObserveUiDataChanged.subscribe((newUiData) => {
      if (me.inHouseHasTableSeat != newUiData.place_no > 0 || me.inHouseIsGroup != newUiData.isGroup || me.inHouseTableOpenItems != newUiData.open_amount || me.inHouseGroupMemberCount != newUiData.customer_count) {
        me.inHouseHasTableSeat = newUiData.place_no > 0;
        me.inHouseIsGroup = newUiData.isGroup;
        me.inHouseTableOpenItems = newUiData.open_amount;
        me.inHouseGroupMemberCount = newUiData.customer_count;
        me.PushChanges();
      }
    });

    // remote order group
    me.displayRemoteOrderGroupIcon$ = me._remoteGroupOrderService.displayGroupNav$;
    me.remoteGroupMemberCount$ = me._remoteGroupOrderService.memberCount$;
    me.groupStatusFinished$ = me._remoteGroupOrderService.groupStatusFinished$;

    me.offlineIndicatorActiveColor = window.getComputedStyle(document.getElementById("offlineindicator")).getPropertyValue("--active-color");

    me._shippingCartSubscriber = me._webShopService.ShippingCartObserver.subscribe((shippingCartItems) => {
      if (shippingCartItems) {
        me.itemsInBasket = me._webShopService.getTotalCountOfItems();
        me.PushChanges();
      } else {
        me.itemsInBasket = 0;
        me.PushChanges();
      }
    });

    me._viewTypeSubscription = me._mainnavService.observeViewTypeChanges.subscribe((viewType) => {
      me.onViewTypeChanges(viewType);
      me.ReloadDataAndRender();
    });

    // Determine whether the app allows the language to be selected.
    me._settingsService.GetSettingsMainNavDataViewModel()
      .then((settingViewModel) => {
        if (settingViewModel.language === "") {
          me._mainnavService.canSelectLanguage = true;
        }
      })
      .catch(() => { me._snackBarService.ShowErrorMessageFailed(54); });

    me._termService.GetImpressumTermViewModel().then(terms => {
      me._mainnavService.terms = terms;
      me.PushChanges();
    });

    me._webShopService.getWebshopSettingsDataModel()
      .then((settings) => {
        me.isRevokeEnabled = settings.use_withdrawal !== undefined && settings.use_withdrawal !== null
          ? settings.use_withdrawal
          : true;
        me.PushChanges();
      })
      .catch((error) => {
        me._coreLogService.error('MainNavComponent.ngOnInit', 'getWebshopSettingsDataModel', error);
      });

    me.DrawPaymentoptionsAsync()
      .then(/* no need to wait, it draws the changes */)
      .catch(error => {
        me._coreLogService.error("MainNavComponent.ngOnInit", "DrawPaymentoptionsAsync catch", error);
      });
    me._webshopSettingsChanged = me._webshopSettingsObsServ.ObserveChanges.subscribe(() => {
      me.DrawPaymentoptionsAsync().then(/* no need to wait, it draws the changes */)
        .catch(error => {
          me._coreLogService.error("MainNavComponent.webshopSettingsObsServ.ObserveChanges", "DrawPaymentoptionsAsync catch", error);
        });
    });

    me.onViewTypeChanges(me._mainnavService.viewType);
    me.ReloadDataAndRender();
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._inHouseUiDataSubscription) {
      me._inHouseUiDataSubscription.unsubscribe();
    }
    if (me._navigationEnabledSubscription) {
      me._navigationEnabledSubscription.unsubscribe();
    }
    if (me._navigationBackSubscription) {
      me._navigationBackSubscription.unsubscribe();
    }
    if (me._mainFooterSubscription) {
      me._mainFooterSubscription.unsubscribe();
    }
    if (me._highLightNavigationSubscription) {
      me._highLightNavigationSubscription.unsubscribe();
    }
    if (me._lastChildRouteDataSubscription) {
      me._lastChildRouteDataSubscription.unsubscribe();
    }
    if (me.langSubscriber) {
      me.langSubscriber.unsubscribe();
    }
    if (me.navigationChangesSubscriber) {
      me.navigationChangesSubscriber.unsubscribe();
    }
    if (me.offlineSupscription) {
      me.offlineSupscription.unsubscribe();
    }
    if (me.onlineSupscription) {
      me.onlineSupscription.unsubscribe();
    }
    if (me._viewTypeSubscription) {
      me._viewTypeSubscription.unsubscribe();
    }
    if (me._shippingCartSubscriber) {
      me._shippingCartSubscriber.unsubscribe();
    }
    if (me._webshopSettingsChanged) {
      me._webshopSettingsChanged.unsubscribe();
    }
    if (me._accessibilityModeSubscription) {
      me._accessibilityModeSubscription.unsubscribe();
    }
  }

  private PushChanges(): void {
    try {
      // we should use markForCheck on this component to solve routing animation problem
      this._changeDetectorRef.markForCheck();
    } catch (e) {
      this._coreLogService.error("MainNavComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  // laden der Communities aus den WebshopSettings
  private async CommunityInfoLoad(): Promise<void> {
    const me = this;
    const webshopSettings = await me._webshopSettingsObsServ.GetObject(WebshopSettingsDMKey);

    me._mainnavService.communities = webshopSettings.communities
      .filter(c => c.isActive && !!c.url)
      .map(c => {
        c.image = `hypersoft_social_${c.name.toLowerCase()}.svg`;
        return c;
      });
    me.PushChanges();
  }

  private async DrawPaymentoptionsAsync(): Promise<void> {
    const me = this;
    const webshopSettings = await me._webshopSettingsObsServ.GetObject(WebshopSettingsDMKey)
    const new_paymentoptions: Paymentoption[] = [];

    let possible_payment_options = ""

    let hs_cash = false;
    let hs_cashless = false;
    let hs_webvoucher = false;
    let hs_paypal = false;
    let hs_accounting = false;
    let hypersoftpay = false;
    webshopSettings.ordertypes.forEach(ordertype => {
      hs_cash = hs_cash || (ordertype.can_cash && ordertype.use_cash);
      hs_cashless = hs_cashless || (ordertype.can_cashless && ordertype.use_cashless);
      hs_webvoucher = hs_webvoucher || (ordertype.can_webvoucher && ordertype.use_webvoucher);
      hs_paypal = hs_paypal || (ordertype.can_paypal && ordertype.use_paypal);
      hs_accounting = hs_accounting || (ordertype.can_accounting && ordertype.use_accounting);
      hypersoftpay = hypersoftpay || (ordertype.can_hypersoftpay && ordertype.use_hypersoftpay);

    });
    if (hs_cash) {
      possible_payment_options += ",hs_cash";
    }
    if (hs_cashless) {
      possible_payment_options += ",hs_cashless";
    }
    if (hs_webvoucher) {
      possible_payment_options += ",hs_webvoucher";
    }
    if (hs_paypal) {
      possible_payment_options += ",hs_paypal";
    }
    if (hs_accounting) {
      possible_payment_options += ",hs_accounting";
    }
    if (hypersoftpay && webshopSettings.adyen_allowed_payment_types) {
      possible_payment_options += "," + webshopSettings.adyen_allowed_payment_types;
    }
    possible_payment_options = "," + possible_payment_options + ","; // vereinfacht die suche

    if (possible_payment_options.includes(",hs_cash,")) {
      new_paymentoptions.push({ name: "hs_cash", image: "checkout/money.svg" });
    }
    // Bargeldlos ist auch die Webguttschein Zahlungsart
    if (possible_payment_options.includes(",hs_cashless,") || possible_payment_options.includes(",hs_webvoucher,")) {
      new_paymentoptions.push({ name: "hs_cashless", image: "checkout/card.svg" });
    }
    /* Webguttschein mit Bargeldlos zusammen
    if (possible_payment_options.includes(",hs_webvoucher,")) {
      new_paymentoptions.push({ name: "hs_webvoucher", image: "checkout/card.svg" });
    }
      */
    if (possible_payment_options.includes(",hs_paypal,")) {
      new_paymentoptions.push({ name: "hs_paypal", image: "adyenpmicons/paypal.svg" }); // momentan ist das Bild von Adyen das richtige
    }
    if (possible_payment_options.includes(",hs_accounting,")) {
      new_paymentoptions.push({ name: "hs_accounting", image: "checkout/accounting.svg" });
    }
    // adyen zahlungsarten
    if (possible_payment_options.includes(",amazonpay,")) {
      new_paymentoptions.push({ name: "amazonpay", image: "adyenpmicons/amazonpay.svg" });
    }
    if (possible_payment_options.includes(",amex,")) {
      new_paymentoptions.push({ name: "amex", image: "adyenpmicons/amex.svg" });
    }
    //? todo nur an Apple?
    if (possible_payment_options.includes(",applepay,")) {
      new_paymentoptions.push({ name: "applepay", image: "adyenpmicons/applepay.svg" });
    }
    if (possible_payment_options.includes(",diners,")) {
      new_paymentoptions.push({ name: "diners", image: "adyenpmicons/diners.svg" });
    }
    if (possible_payment_options.includes(",discover,")) {
      new_paymentoptions.push({ name: "discover", image: "adyenpmicons/discover.svg" });
    }
    if (possible_payment_options.includes(",directEbanking,")) {
      new_paymentoptions.push({ name: "directEbanking", image: "adyenpmicons/directEbanking.svg" });
    }
    //? todo nur an nicht Apple?
    if (possible_payment_options.includes(",paywithgoogle,")) {
      new_paymentoptions.push({ name: "paywithgoogle", image: "adyenpmicons/paywithgoogle.svg" });
    }
    if (possible_payment_options.includes(",jcb,")) {
      new_paymentoptions.push({ name: "jcb", image: "adyenpmicons/jcb.svg" });
    }
    if (possible_payment_options.includes(",klarna_paynow,")) {
      new_paymentoptions.push({ name: "klarna_paynow", image: "adyenpmicons/klarna_paynow.svg" });
    }
    if (possible_payment_options.includes(",mc,")) {
      new_paymentoptions.push({ name: "mc", image: "adyenpmicons/mc.svg" });
    }
    if (possible_payment_options.includes(",paypal,")) {
      new_paymentoptions.push({ name: "paypal", image: "adyenpmicons/paypal.svg" });
    }
    if (possible_payment_options.includes(",twint,")) {
      new_paymentoptions.push({ name: "twint", image: "adyenpmicons/twint.svg" });
    }
    if (possible_payment_options.includes(",visa,")) {
      new_paymentoptions.push({ name: "visa", image: "adyenpmicons/visa.svg" });
    }
    if (possible_payment_options.includes(",wallee,")) {
      new_paymentoptions.push({ name: "wallee", image: "wallee/wallee.svg" });
    }
    // Wenn die Zahlungsarten sich geändert haben, dann die UI aktualisieren
    if (new_paymentoptions.join(",") != me._mainnavService.paymentoptions.join(",")) {
      me._mainnavService.paymentoptions = new_paymentoptions;
      me.PushChanges();
    }
    return;
  }

  public get mandatoryPayment() {
    const me = this;
    return me._InHouseOrderService.TableData.mandatory_Payment;
  }

  /**if member count > limitcount display: 9+ */
  public get showInhouseGroupMemberCount(): string {
    const me = this;
    let limitCount = 9;
    return me.inHouseGroupMemberCount > limitCount ? limitCount.toString() + '+' : me.inHouseGroupMemberCount.toString()
  }

  private onViewTypeChanges(viewType: ViewType) {
    const me = this;
    me.isSmallView = (viewType === ViewType.Small);
  }

  public ReloadDataAndRender(): void {
    const me = this;
    me._navigationService.GetActiveNavigation()
      .then((navigations) => {
        // me.setRouteModulName(navigations);
        me.setNavigationArrays(navigations);
        me.setRouteModulName(navigations);
        me.isLocationModuleActive = navigations.some((nav) => nav.contentType === ContentType.Location);
        me.PushChanges();
      })
      .catch(() => {
        me.PushChanges();
        me._snackBarService.ShowErrorMessageFailed(55);
      });
  }

  private _setHtmlLanguage(lang) {
    document.documentElement.lang = lang;
  }

  /** Determines if the current order mode is a remote group order.*/
  public get isRemoteOrderGroup(): boolean {
    const me = this;
    const orderMode = me._webShopService.getServiceMode();
    const group_delivery = orderMode === WebShopMode.DeliveryGroup;
    const group_pickup = orderMode === WebShopMode.PickupGroup;
    return group_delivery || group_pickup;
  }

  /**if member count > limitcount display: 9+ */
  public showRemoteGroupMemberCount(count: number): string {
    const me = this;
    let limitCount = 9;
    return !Utils.IsNull(count) && count > limitCount ? limitCount.toString() + '+' : count.toString();
  }

  /**
   * set router data pageTitle. It add data to routing config that used as pageTitle in each Module that has dynamic page header.
   * @param navigations list of navigations
   */
  private setRouteModulName(navigations: NavigationViewModel[]): void {
    const me = this;
    const dynamicHeaderRoutes = me._router.config.find(r => r.path === "").children;
    dynamicHeaderRoutes.forEach(route => {
      const path = route.data["moduleNameReference"] ? route.data["moduleNameReference"] : route.path === "" ? "home" : route.path.split("/")[0];
      const navigation = navigations.find(n => me._navigationService.GetNavigationPathForContentType(n.contentType) === path);
      if (navigation) {
        route.data["pageTitle"] = me._navigationService.GetRouteNavigationTitleViewModel(navigation);
      }
    });
  }

  /**
   * set navigation for footer and side bar
   * @param navigations list of navigation
   */
  private setNavigationArrays(navigations: NavigationViewModel[]): void {
    const me = this;
    if (!me.isSmallView) {
      me.mainMenu = [];
      me.subMenu = navigations;
    } else if (navigations.length < 5) {
      me.fullFooterMenu = false;
      me.mainMenu = navigations.slice(0, navigations.length - 1);
      me.subMenu = navigations.slice(navigations.length - 1);
    } else {
      me.fullFooterMenu = true;
      me.mainMenu = navigations.slice(0, 4);
      me.subMenu = navigations.slice(4);
    }
  }

  public navigateToModule(event: any, navigationViewModel: NavigationViewModel) {
    const me = this;
    if (navigationViewModel.contentType !== ContentType.ExternalLink) {
      if (navigationViewModel.navigationKey === "/location") {
        me._locationService.GetSingleLocationData()
          .then(location => {
            if (location) {
              me._router.navigate(["/locationdetail", location.hyp_cus_nr]);
            } else {
              me._router.navigate([navigationViewModel.navigationKey]);
            }
          })
          .catch(e => {
            me._snackBarService.ShowErrorMessageFailed(56);
            me._coreLogService.error("MainNavComponent.navigateToModule", "_locationService.GetSingleLocationData", e);
          })
      } else {
        me._router.navigate([`${navigationViewModel.navigationKey === "home" ? "" : navigationViewModel.navigationKey}`]);
      }
      if (me.isSmallView) { me.drawer.close(); }
    } else {
      me._externalLinksSettingsService.RouteToExternalLinks()
        .then(() => {
          if (me.isSmallView) { me.drawer.close(); }
        })
        .catch(e => {
          if (me.isSmallView) { me.drawer.close(); }
          me._coreLogService.error("MainNavComponent.navigateToModule", "RouteToExternalLinks (catch)", e);
        });
    }
  }

  public toggleSideNav(show: boolean | null = null) {
    const me = this;
    if (show != null) {
      if (show) {
        me.drawer.open();
      } else { me.drawer.close(); }
    } else {
      if (me.drawer.opened) {
        me.drawer.close();
      } else { me.drawer.open(); }
    }
  }

  private setTargetModuleHighlight(contentType: number) {
    const navigationClassElements = Array.from(document.getElementsByClassName("navigation-class"));
    const sideNavigationClassElements = Array.from(document.getElementsByClassName("side-navigation-class"));
    navigationClassElements.push(...sideNavigationClassElements);
    navigationClassElements.forEach(element => {
      element.classList.remove("highlight-icon");
      element.classList.remove("side-highlight-icon");
    });
    const elementId = `navigation${contentType}`;
    let isSideNavElement = false;
    for (let i = 0; i < sideNavigationClassElements.length; i++) {
      const element = sideNavigationClassElements[i];
      if (element.id === elementId) {
        isSideNavElement = true;
        break;
      }
    }
    const target: HTMLElement = document.getElementById(elementId);
    if (target) {
      if (isSideNavElement && this.isMobile) {
        document.getElementById("moreMenu").classList.add("highlight-icon");
      }
      if (isSideNavElement) {
        target.classList.add("side-highlight-icon");
      } else {
        target.classList.add("highlight-icon");
      }
    }
  }

  /**
    * If a user needs login or registeration, by click on top left icon, this modalDialog will be opened to redirect user to login page
    */
  public openLoginDialog(): void {
    const me = this;
    me._bottomSheetHelperService.open(LoginDialogComponent);
  }

  public openCookieDialog() {
    const me = this;
    me._bottomSheetHelperService.open(CookiePolicyComponent);
  }

  public openLicenseDialog() {
    const me = this;
    me._bottomSheetHelperService.open(LicenseDialogComponent);
  }

  /** todo nur debug */
  public openSnackBar(): void {
    const me = this;
    me._snackBarService.ShowMessage(snackBarMessageKey.copiedToClipboard, SnackBarMessageType.Successful);
  }

  /** todo nur debug */
  private urlB64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/\-/g, '+')
      .replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }
  /** todo nur debug */
  public registerPushNotification(): void {
    const me = this;
    // grant notification permission
    if (typeof Notification !== "undefined") {

      Notification.requestPermission().then(async (permission) => {
        if (permission === "granted") {
          console.info("permission granted.");

          let VAPID_PUBLIC_KEY = ""; // initial ist es leer, also muss sie dem Server bekannt sein
          VAPID_PUBLIC_KEY = "BNuq83xTB-UUg9Uytyio3EeIkTl1sDQIEX7voYBgK_yuYUuK15gFE_KsC3gii0My2xQFUrHc52vU4PkdcbOaaDc"; // todo remove, and implement on server
          const registration = await navigator.serviceWorker.getRegistration();
          let subscription = await registration.pushManager.getSubscription();
          //subscription.unsubscribe();
          if (!subscription) {
            // create new subscription
            const response = await fetch("/push/api/notification/GetPublicKey", { method: "GET" });
            if (!response.ok) {
              console.error('fail get vapid_public_key', response.statusText);
              return;
            } else {
              VAPID_PUBLIC_KEY = "BNuq83xTB-UUg9Uytyio3EeIkTl1sDQIEX7voYBgK_yuYUuK15gFE_KsC3gii0My2xQFUrHc52vU4PkdcbOaaDc"; // todo
              //VAPID_PUBLIC_KEY = await response.body.getReader().read();
              subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: me.urlB64ToUint8Array(VAPID_PUBLIC_KEY)
              });
              console.info('created new subscription', subscription);
            }
          } else {
            console.info('has old subscription', subscription);
            // todo need refresh
            me._snackBarService.ShowMessage("_AlreadySubscribet", SnackBarMessageType.Warning);
          }

          console.info('try send subscription', JSON.stringify(subscription));
          //notifyMeButton.disabled = false;
          fetch("/push/api/notification/SetSubscription", {
            method: "POST",
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ type: "push", publickey: VAPID_PUBLIC_KEY, data: JSON.stringify(subscription) })
          }).then((response) => {
            console.info("SetSubscription response", response);
            me._snackBarService.ShowMessage("_NowCanReciveMsg", SnackBarMessageType.Successful);
          }).catch((error) => {
            console.info("SetSubscription catch", error);
            me._snackBarService.ShowMessage("_NowCanReciveMsg", SnackBarMessageType.Error);
          });

        } else {
          console.error("no permission.", { permission });
          me._snackBarService.ShowMessage("_NoPermission", SnackBarMessageType.Error);
        }
      }).catch((error) => {
        console.info("requestPermission catch", error);
      });
    } else {
      me._snackBarService.ShowMessage("_NoNotification", SnackBarMessageType.Error); // zumbeispiel beim iPhone
      console.log("try iphone");

      let VAPID_PUBLIC_KEY = ""; // initial ist es leer, also muss sie dem Server bekannt sein
      VAPID_PUBLIC_KEY = "BNuq83xTB-UUg9Uytyio3EeIkTl1sDQIEX7voYBgK_yuYUuK15gFE_KsC3gii0My2xQFUrHc52vU4PkdcbOaaDc"; // todo remove, and implement on server

      navigator.serviceWorker.ready.then(async (serviceWorkerRegistration) => {
        const options = {
          userVisibleOnly: true,
          applicationServerKey: me.urlB64ToUint8Array(VAPID_PUBLIC_KEY),
        };

        const perms = await serviceWorkerRegistration.pushManager.permissionState(options);
        console.log("permissions", perms);

        serviceWorkerRegistration.pushManager.subscribe(options).then(
          (pushSubscription) => {
            console.log("subscribe", { pushSubscription });
            // The push subscription details needed by the application
            // server are now available, and can be sent to it using,
            // for example, an XMLHttpRequest.
          },
          (error) => {
            // During development it often helps to log errors to the
            // console. In a production environment it might make sense to
            // also report information about errors back to the
            // application server.
            console.error("error", error);
          }
        ).catch((error) => {
          console.error("catch", error);
        });
      });
    }

  }
  /** todo nur debug */
  public unregisterPushNotification(): void {
    const me = this;
    me._snackBarService.ShowMessage("_NotImplemented", SnackBarMessageType.Error);

  }
  /** todo nur debug */
  public sendPushNotification(): void {
    const me = this;
    fetch("/push/api/notification/Send?body=halloYA", { method: "GET" }).then((response) => {
      console.info("sendPushNotification response", response);
      me._snackBarService.ShowMessage("_Success", SnackBarMessageType.Successful);
    }).catch((error) => {
      console.info("requestPermission catch", error);
      me._snackBarService.ShowErrorMessageFailed(57);
    });
  }
  /**Um FCM neugenerierung zu testen */
  public resetFCM(): void {
    const me = this;
    me._coreCOMService.environment.valueStorage
      .set(StorageHive.Local, LocalKeys.yourAppDeviceFCMToken, null)
      .catch((e) => {
        console.info("requestPermission catch", e);
        me._snackBarService.ShowErrorMessageFailed(58);
      });
  }
  /** todo nur debug */
  public registerSMSNotification(): void {
    const me = this;
    // grant notification permission
    if (typeof Notification !== "undefined") {
      const smsnumber = $("#smsnumber").val().toString().trim();

      console.info('try register smsnumber', smsnumber);
      me._snackBarService.ShowMessage("_NotImplemented", SnackBarMessageType.Error);

      fetch("/push/api/notification/SetSubscription", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ type: "sms", data: smsnumber })
      }).then((response) => {
        console.info("SetSubscription response", response);
        me._snackBarService.ShowMessage("_NowCanReciveMsg", SnackBarMessageType.Successful);
      }).catch((error) => {
        console.info("SetSubscription catch", error);
        me._snackBarService.ShowMessage("_NowCanReciveMsg", SnackBarMessageType.Error);
      });
    }
  }
  /** todo nur debug */
  public unregisterSMSNotification(): void {
    const me = this;
    me._snackBarService.ShowMessage("_NotImplemented", SnackBarMessageType.Error);

  }
  /** todo nur debug */
  public sendSMSNotification(): void {
    const me = this;
    me._snackBarService.ShowMessage("_NotImplemented", SnackBarMessageType.Error);
    fetch("/push/api/notification/Send?body=halloYA", { method: "GET" }).then((response) => {
      console.info("sendPushNotification response", response);
      me._snackBarService.ShowMessage("_Success", SnackBarMessageType.Successful);
    }).catch((error) => {
      console.info("requestPermission catch", error);
      me._snackBarService.ShowErrorMessageFailed(59);
    });
  }

  /** öffnet externen Link zu Communitys */
  public openExternalUrl(url: string): void {
    const me = this;
    me._externalLinksSettingsService.RouteToExternalLinks(url, true)
      .then(() => {/* run async  */ })
      .catch(error => {
        me._coreLogService.error("MainNavComponent.openExternalUrl", "RouteToExternalLinks (catch)", error);
        me._snackBarService.ShowErrorMessageFailed(127);
      });
  }

  public openLanguageDialog(): void {
    const me = this;
    me._bottomSheetHelperService.open(LanguageDialogComponent);
    if (me.isSmallView) {
      me.drawer.close();
    }
  }
  public openAccessibiltyDialog(): void {
    const me = this;
    me._bottomSheetHelperService.open(AccessibiltyDialogComponent, {
      data: {
        applyAccessibilitySettings: () => {
          me._accessibilityWebShopService.applyAccessibilitySettings();
          me._mainnavService.isAccessibilityModeActive = me._accessibilityWebShopService.getAccessibilityModeActive();
          me.PushChanges();
        }
      },
      panelClass: "mat-bottom-sheet-container--medium"
    }).afterDismissed().subscribe(() => {
      me._mainnavService.isAccessibilityModeActive = me._accessibilityWebShopService.getAccessibilityModeActive();
      me.PushChanges();
    });

    if (me.isSmallView) {
      me.drawer.close();
    }
  }

  public openChangeLocationDialog(): void {
    const me = this;
    const locationID = me._webShopService.locationID;
    let hasOneLocation = false;
    if (locationID) {
      const serviceMode = me._webShopService.getServiceMode();
      if (serviceMode === WebShopMode.TakeAway || serviceMode === WebShopMode.Webvoucher) {
        me._menuSettingObsServ.GetObject(MenuSettingsDMKey)
          .then(menusetting => {
            me._locationService.GetWebshopGuardSingleLocationData(serviceMode, menusetting.locations)
              .then((webShopLocations) => {
                if (webShopLocations && webShopLocations.length === 1) {
                  hasOneLocation = true;
                }
                const serviceMode = me._webShopService.getServiceMode();
                me._bottomSheetHelperService.open(MenuChangeLocationDialogComponent, {
                  // for webvoucher service we show the regular openning time, so we send WebShopMode.Viewing to get opentime for viewing
                  data: { locationID: locationID, serviceID: serviceMode === WebShopMode.Webvoucher ? WebShopMode.Viewing : serviceMode, hasOneLocation: hasOneLocation },
                  panelClass: "mat-bottom-sheet-container--full-height"
                });
              })
              .catch(e => {
                me.objObsInjectHelper.coreLogService.error("CheckWebShopSingleLocationGuard.resolve", "_locationService.GetWebshopLocationViewModel", e);
              });
          })
          .catch(e => {
            me.objObsInjectHelper.coreLogService.error("CheckWebShopSingleLocationGuard.resolve", "_menuSettingObsServ.GetObject", e);
          });
      } else {
        if (me.isRemoteOrderGroup) {
          me._webShopService.openWarningLeaveGroup(locationID, serviceMode, true);
        } else {
          me._bottomSheetHelperService.open(MenuChangeLocationDialogComponent, {
            data: { locationID: locationID, serviceID: me._webShopService.getServiceMode(), hasOneLocation: hasOneLocation },
            panelClass: "mat-bottom-sheet-container--full-height"
          });
        }

      }
    }
  }

  public navigateToHomePage() {
    const me = this;
    me._router.navigateByUrl("/");
  }

  /** Navigates to the revoke-order page and closes the sidenav when in mobile view. */
  public navigateToRevokeOrder(): void {
    const me = this;
    me._router.navigate([NavigationRoute.RevokeOrder]);
    if (me.isSmallView) { me.drawer.close(); }
  }

  public navigateToTerms(termID: number) {
    const me = this;
    me._router.navigate(["/termcondition", termID]);
  }

  public getVersionAsString(): string {
    return `v${appConfig.version}`;
  }
}
